module.exports = __webpack_public_path__ + "img/share-ios.f26ab7cc.png";